export const Env = Object.freeze({
	DEVELOP: 'develop',
	STAGING: 'staging',
	PRODUCTION: 'production',
});